export default __webpack_public_path__ + "static/media/road_img_8_8.b423de71.jpg";